/**
 * NON-G2RS mode feature flag (inverse of the compliance mode).
 *
 * The site defaults to G2RS compliance mode: AI surfaces (Copiloto chat,
 * AI reports, AI summaries, AI research tools), rankings and
 * investment-ideas pages are hidden while the Google Ads financial-services
 * verification (G2RS) review is in progress, leaving only factual data and
 * portfolio-tracking features.
 *
 * Toggle the `NON_G2RS_MODE` feature flag (admin dashboard → Feature Flags)
 * to show the full product. The flag is database-backed and resolved at
 * request time: absent or disabled flag means compliance mode (reduced
 * site). Server code on user-facing surfaces resolves it with
 * `!(await isFeatureEnabledForSession(NON_G2RS_FEATURE_FLAG))` so the
 * per-user allowlist applies; only bot-facing code (e.g. the sitemap)
 * resolves the global toggle with `isFeatureEnabled` directly. Client
 * components receive the resolved boolean as a `g2rsMode` prop (or the
 * `initialG2rsMode` navbar prop) from their server parents.
 */
export const NON_G2RS_FEATURE_FLAG = 'NON_G2RS_MODE';

/** Standard 404 for gated API routes while G2RS mode is enabled. */
export function g2rsModeBlockedResponse(): Response {
  return new Response(null, { status: 404 });
}
